module.exports = __webpack_public_path__ + "static/media/drawer2-flower.bdd29e41.png";